(() => {
  if (!customElements.get('ash-home-hero')) {
    class AshHomeHero extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-ash-hero-slide]')];
        this.progress = [...this.querySelectorAll('[data-ash-hero-progress]')];
        this.index = 0;
        this.delay = Math.max(Number(this.dataset.delay) || 7000, 5000);
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onVisibilityChange = () => document.hidden ? this.stop() : this.start();
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
      }

      start() {
        this.stop();
        if (this.slides.length < 2 || this.reducedMotion.matches || document.hidden) return;
        this.timer = window.setInterval(() => this.show((this.index + 1) % this.slides.length), this.delay);
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }

      show(nextIndex) {
        this.slides.forEach((slide, index) => {
          const active = index === nextIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          this.progress[index]?.classList.toggle('is-active', active);
        });
        this.index = nextIndex;
      }
    }

    customElements.define('ash-home-hero', AshHomeHero);
  }

  const initialiseFilm = (section) => {
    if (section.dataset.ashFilmReady === 'true') return;
    section.dataset.ashFilmReady = 'true';
    const video = section.querySelector('video');
    if (!video) return;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const load = () => {
      if (video.dataset.loaded === 'true' || reducedMotion.matches) return;
      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      video.dataset.loaded = 'true';
      video.load();
      video.play().catch(() => {});
    };

    if (!('IntersectionObserver' in window)) {
      load();
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          load();
          if (!reducedMotion.matches) video.play().catch(() => {});
        } else if (!video.paused) {
          video.pause();
        }
      });
    }, { rootMargin: '300px 0px' });
    observer.observe(section);
  };

  document.querySelectorAll('[data-ash-home-film]').forEach(initialiseFilm);
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-ash-home-film]');
    if (section) initialiseFilm(section);
  });
})();
